import React from 'react'
import { Row, Col, FormGroup, FormControl, ControlLabel } from 'react-bootstrap'
import i18next from 'i18next'
import GridContainer from './GridContainer'
import Button from './Button'

import adminStyles from './styles/admin.scss'

export default class OrganisationCreation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      name: '',
      notes: '',
      unitPriceWopi: 0,
      creditsWopi: 0,
      creditsWopi360: 0,
      isValid: false
    }
  }

  render() {
    return (
      <GridContainer>
        <div className={adminStyles.app}>
          <header>
            <h1>{i18next.t('new_organisation')}</h1>
          </header>

          <Row>
            <Col md={12}>
              <Row>
                <Col md={12}>
                  <FormGroup controlId="name">
                    <ControlLabel>{i18next.t('organisation_name')}</ControlLabel>
                    <FormControl
                      name="name"
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.name}
                    />
                  </FormGroup>

                  <FormGroup controlId="notes">
                    <ControlLabel>{i18next.t('notes')}</ControlLabel>

                    <FormControl
                      name="notes"
                      componentClass="textarea"
                      onChange={this.handleChange}
                      value={this.state.signature}
                      rows="4"
                    />
                  </FormGroup>

                  <FormGroup controlId="unitPriceWopi">
                    <ControlLabel>{i18next.t('unit_price_wopi')}</ControlLabel>

                    <FormControl
                      name="unitPriceWopi"
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.unitPriceWopi}
                    />
                  </FormGroup>

                  <FormGroup controlId="creditsWopi">
                    <ControlLabel>{i18next.t('wopi_credits')}</ControlLabel>

                    <FormControl
                      name="creditsWopi"
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.creditsWopi}
                    />
                  </FormGroup>

                  <FormGroup controlId="creditsWopi360">
                    <ControlLabel>{i18next.t('wopi_360_credits')}</ControlLabel>

                    <FormControl
                      name="creditsWopi360"
                      type="text"
                      onChange={this.handleChange}
                      value={this.state.creditsWopi360}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
          </Row>

          <div>
            <Button
              text={i18next.t('save')}
              onClick={this.handleAdd}
              disabled={!this.state.isValid}
            />
          </div>
        </div>
      </GridContainer>
    )
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value }, this.validateState)
  }

  validateState() {
    const validate = () =>
      this.state.name.trim() !== '' &&
      parseInt(this.state.unitPriceWopi) >= 0 &&
      !isNaN(parseInt(this.state.creditsWopi))

    this.setState({ isValid: validate() })
  }

  handleAdd = e => {
    const { onAdd } = this.props
    const { name, notes, unitPriceWopi, creditsWopi, creditsWopi360 } = this.state

    onAdd(name, notes, unitPriceWopi, creditsWopi, creditsWopi360)
  }
}



// WEBPACK FOOTER //
// ./src/components/OrganisationCreation.js